import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors';
import { Scroll } from 'vuetify/lib/directives';

Vue.use(Vuetify, {
  directives: {
    Scroll,
  },
});

export default new Vuetify({
  theme: {
    themes: {
      light: {
        // primary: '#13d5ab',
        primary: '#68CDC7',
        secondary: colors.blue.lighten1, // #FFCDD2
        accent: colors.blue.lighten1,
      },
    },
  },
});
